var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIterate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.447 44.314l2.779-14.921c.056-.388-.222-.721-.556-.721H11.61a.6.6 0 01-.5-.943L27.672 3.267c.389-.555 1.223-.166 1.056.444L25.783 18.41c-.056.388.222.721.556.721h11.06c.445 0 .778.499.5.943L21.503 44.758c-.334.499-1.167.166-1.056-.444z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OSIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ5IDQ4IiBmaWxsPSJub25lIiB4bWxuczp2PSJodHRwczovL3ZlY3RhLmlvL25hbm8iPjxwYXRoIGQ9Ik0yMC40NDcgNDQuMzE0bDIuNzc5LTE0LjkyMWMuMDU2LS4zODgtLjIyMi0uNzIxLS41NTYtLjcyMUgxMS42MWEuNi42IDAgMCAxLS41LS45NDNMMjcuNjcyIDMuMjY3Yy4zODktLjU1NSAxLjIyMy0uMTY2IDEuMDU2LjQ0NEwyNS43ODMgMTguNDFjLS4wNTYuMzg4LjIyMi43MjEuNTU2LjcyMWgxMS4wNmMuNDQ1IDAgLjc3OC40OTkuNS45NDNMMjEuNTAzIDQ0Ljc1OGMtLjMzNC40OTktMS4xNjcuMTY2LTEuMDU2LS40NDR6IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";
export { SvgIconIterate as ReactComponent };